module.exports = __webpack_public_path__ + "img/tiktok-qr.918e118c.jpg";